import { render, staticRenderFns } from "./NotifikacijaForma.vue?vue&type=template&id=6d374322&scoped=true&"
import script from "./NotifikacijaForma.vue?vue&type=script&lang=js&"
export * from "./NotifikacijaForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d374322",
  null
  
)

export default component.exports